import IMounter from "./types/core/IMounter";
import Frameworks from "./frameworks/Frameworks";

export default class AppMounter implements IMounter {
    public mount(): void {
        Frameworks.getVue().mount();
    }
}
